import request from '@webtrader/core/request';
import { ITradingAccountBalances } from '@webtrader/core/services/auth/service';

import { ESymbolType } from '../market/symbols';

export interface IStatisticsAccount {
  credit: number;
  deposit: number;
  withdrawal: number;
  realisedProfit: number;
  user: string;
  group: string;
  accountBalance: ITradingAccountBalances;
}

export interface IProfitStatistic {
  date: number;
  profitLoss: number;
}

export interface IProfitStatisticsParams {
  days: number;
}

export interface IAssetStatistic {
  assetWorth: number;
  symbolType: ESymbolType;
}

export interface IAssetStatisticResult {
  totalAssetWorth: number;
  typeAssetList: IAssetStatistic[];
}

export default {
  statisticsAccount: (abortSignal?: AbortSignal) => {
    return request.get<IStatisticsAccount>('/api/statistics/v1/account', { signal: abortSignal });
  },
  profitsStatistics: (params: IProfitStatisticsParams, abortSignal?: AbortSignal) => {
    return request.get<IProfitStatistic[]>('/api/statistics/v1/profits', {
      params,
      signal: abortSignal
    });
  },
  assetsStatistics: (abortSignal?: AbortSignal) => {
    return request.get<IAssetStatisticResult>('/api/statistics/v1/daily', { signal: abortSignal });
  }
};
